// Dictionnaire anglais — la clé est la chaîne française source.
// Toute clé absente retombe automatiquement sur le français.
export const EN = {
  // Navigation & header
  "Accueil": "Home",
  "Explorer": "Explore",
  "Ce soir": "Tonight",
  "Événements": "Events",
  "Hébergements": "Stays",
  "Connexion": "Log in",
  "Inscription": "Sign up",
  "Mon profil": "My profile",
  "Panneau admin": "Admin panel",
  "Mon établissement": "My establishment",
  "Se déconnecter": "Log out",
  "Déconnexion": "Log out",
  "Mes favoris": "My favourites",
  "Menu": "Menu",
  "Menu principal": "Main menu",
  "Fermer": "Close",
  "Langue": "Language",
  "Français": "Français",
  "Anglais": "English",

  // Catégories & filtres (correspondance fixe)
  "Bars": "Bars",
  "Karaoké": "Karaoke",
  "Restaurants": "Restaurants",
  "Soirées": "Nightlife",
  "Activités": "Activities",
  "Concerts": "Concerts",
  "Humour": "Comedy",
  "Hôtels": "Hotels",
  "Auberges": "Inns",
  "Auberges de jeunesse": "Hostels",
  "Happy Hour": "Happy Hour",
  "Tous": "All",
  "Tout": "All",
  "Tous les quartiers": "All neighbourhoods",
  "Tous les prix": "All prices",
  "Toutes catégories": "All categories",
  "Toutes les dates": "All dates",
  "Toutes distances": "Any distance",
  "Toutes les notes": "Any rating",
  "Tous les horaires": "Any time",
  "Aujourd’hui": "Today",
  "Demain": "Tomorrow",
  "Ce week-end": "This weekend",
  "Cette semaine": "This week",
  "Payant": "Paid",
  "Moins de 500 m": "Under 500 m",
  "Moins de 1 km": "Under 1 km",
  "Moins de 2 km": "Under 2 km",
  "4,0 et plus": "4.0 and up",
  "4,5 et plus": "4.5 and up",
  "150 $ et moins": "$150 and under",
  "300 $ et moins": "$300 and under",

  // Statuts & badges
  "Populaire": "Popular",
  "Nouveau": "New",
  "Soirée": "Nightlife",
  "Soirée DJ": "DJ Night",
  "Concert Live": "Live Concert",
  "Concert": "Concert",
  "Événement": "Event",
  "Activité": "Activity",
  "Ouvert": "Open",
  "Ouvert maintenant": "Open now",
  "Fermé": "Closed",
  "Confirmée": "Confirmed",
  "Refusée": "Declined",
  "Annulée": "Cancelled",
  "En attente": "Pending",
  "Brouillon": "Draft",
  "Programmé": "Scheduled",
  "Publié": "Published",
  "Terminé": "Ended",
  "Payée": "Paid",
  "Masqué": "Hidden",
  "Signalé": "Reported",
  "Actif": "Active",
  "Vérifié": "Verified",

  // Jours
  "Lundi": "Monday",
  "Mardi": "Tuesday",
  "Mercredi": "Wednesday",
  "Jeudi": "Thursday",
  "Vendredi": "Friday",
  "Samedi": "Saturday",
  "Dimanche": "Sunday",

  // Commun
  "Rechercher": "Search",
  "Annuler": "Cancel",
  "Confirmer": "Confirm",
  "Enregistrer": "Save",
  "Enregistrement…": "Saving…",
  "Retour": "Back",
  "Continuer": "Continue",
  "Voir tout": "See all",
  "Voir toutes": "See all",
  "Voir la carte": "See map",
  "Voir la fiche →": "View details →",
  "Voir sur la carte": "See on the map",
  "Chargement...": "Loading...",
  "En ce moment": "Right now",
  "Gratuit": "Free",
  "Gratuit seulement": "Free only",
  "Bientôt": "Coming soon",
  "avis": "reviews",
  "Trier par :": "Sort by:",
  "proximité": "distance",
  "note": "rating",
  "Note": "Rating",
  "Prix par nuit": "Price per night",
  "Soirées populaires": "Popular nights out",
  "Événements ce soir": "Events tonight",
  "Évolution de l'activité": "Activity trend",
  "Distance": "Distance",
  "Prix": "Price",
  "Défiler": "Scroll",
  "Happy Hour ce soir": "Happy Hour tonight",
  "Forfait / abonnement": "Plan / subscription",
  "Ces informations identifient ton compte propriétaire.": "This information identifies your owner account.",
  "Choisis les alertes que tu veux recevoir.": "Choose which alerts you want to receive.",
  "Choisis un mot de passe d'au moins 6 caractères.": "Choose a password of at least 6 characters.",
  "Ton abonnement GoSpot Pro.": "Your GoSpot Pro subscription.",
  "nom": "name",
  "prix": "price",
  "Modifier": "Edit",
  "Éditer": "Edit",
  "Supprimer": "Delete",
  "Retirer": "Remove",
  "Dupliquer": "Duplicate",
  "Ajouter": "Add",
  "Envoyer": "Send",
  "Envoi en cours…": "Sending…",
  "Optionnel": "Optional",
  "Détails": "Details",
  "Détails (optionnel)": "Details (optional)",
  "Date": "Date",
  "Heure": "Time",
  "Statut": "Status",
  "Rôle": "Role",
  "Actions": "Actions",
  "Catégorie": "Category",
  "Catégories": "Categories",
  "Quartier": "Neighbourhood",
  "Client": "Client",
  "Personnes": "People",
  "Calendrier": "Calendar",
  "Carte": "Map",
  "Liste": "List",
  "Admin": "Admin",
  "Administrateur": "Administrator",
  "Un instant…": "One moment…",
  "Rapport exporté en CSV": "Report exported to CSV",

  // Accueil
  "GoSpot — Trouve quoi faire près de toi": "GoSpot — Find something to do near you",
  "Trouve quoi faire près de toi.": "Find something to do near you.",
  "Bars, karaokés, restaurants, soirées, activités, hébergements et événements : trouve quoi faire ce soir à Québec.": "Bars, karaoke, restaurants, nightlife, activities, stays and events: find something to do tonight in Quebec City.",
  "Ex. : restaurant, karaoké, événement, bar…": "E.g.: restaurant, karaoke, event, bar…",
  "Vue panoramique de Québec et du Château Frontenac au coucher du soleil": "Panoramic view of Quebec City and the Château Frontenac at sunset",
  "Tendances ce soir": "Trending tonight",
  "Près de vous": "Near you",
  "Près de toi": "Near you",
  "Explorer par quartier": "Explore by neighbourhood",
  "Événements ce week-end": "Events this weekend",
  "Le quartier branché": "The trendy district",
  "Le cœur historique": "The historic heart",
  "La vie nocturne": "The nightlife scene",
  "Découvre les meilleurs endroits près de ta position.": "Discover the best places near your location.",
  "Les meilleurs spots": "The best spots",
  "Sélectionnés et notés par la communauté GoSpot.": "Handpicked and rated by the GoSpot community.",
  "Événements exclusifs": "Exclusive events",
  "Accède à des événements uniques et locaux.": "Get access to unique local events.",
  "Tes favoris": "Your favourites",
  "Enregistre tes coups de cœur et retrouve-les facilement.": "Save your favourites and find them easily.",
  "Application mobile": "Mobile app",

  // Explorer
  "Explorer — GoSpot": "Explore — GoSpot",
  "Explore les meilleurs bars, karaokés, restaurants, activités et hébergements à Québec.": "Explore the best bars, karaoke, restaurants, activities and stays in Quebec City.",
  "Explorer les meilleurs spots": "Explore the best spots",
  "Trouve bars, karaokés, restaurants, activités et hébergements près de toi.": "Find bars, karaoke, restaurants, activities and stays near you.",
  "Château Frontenac à Québec": "Château Frontenac in Quebec City",
  "Aucun résultat": "No results",
  "Essaie d’ajuster ta recherche ou tes filtres.": "Try adjusting your search or filters.",
  "Essaie d’ajuster tes filtres.": "Try adjusting your filters.",
  "Réinitialiser les filtres": "Reset filters",
  "Réinitialiser": "Reset",
  "Recommandé pour toi": "Recommended for you",
  "Rechercher un établissement, un quartier…": "Search for a place, a neighbourhood…",

  // Ce soir
  "Ce soir à Québec — GoSpot": "Tonight in Quebec City — GoSpot",
  "Découvre les meilleures soirées, événements et happy hours à Québec ce soir.": "Discover the best nights out, events and happy hours in Quebec City tonight.",
  "Découvrez les meilleures soirées et événements près de vous.": "Discover the best nights out and events near you.",
  "Rien pour ce filtre ce soir": "Nothing for this filter tonight",
  "Essaie une autre catégorie.": "Try another category.",
  "Basé sur votre position": "Based on your location",
  "Actualiser ma position": "Refresh my location",
  "Voir toutes les catégories": "See all categories",
  "Autour de vous": "Around you",
  "Ne manquez rien ce soir !": "Don't miss anything tonight!",
  "Activez les notifications et recevez les meilleures suggestions.": "Turn on notifications and get the best suggestions.",
  "Activer les notifications": "Turn on notifications",
  "Notifications activées": "Notifications on",
  "Notifications activées — à ce soir !": "Notifications on — see you tonight!",
  "Notifications refusées par le navigateur": "Notifications blocked by the browser",
  "Les notifications ne sont pas supportées ici": "Notifications are not supported here",
  "Impossible d'activer les notifications ici": "Unable to turn on notifications here",

  // Événements
  "Événements à Québec — GoSpot": "Events in Quebec City — GoSpot",
  "Concerts, karaokés, soirées, activités et événements près de vous à Québec.": "Concerts, karaoke, nightlife, activities and events near you in Quebec City.",
  "Événements à Québec": "Events in Quebec City",
  "Concerts, karaokés, soirées, activités et événements près de vous.": "Concerts, karaoke, nightlife, activities and events near you.",
  "Rechercher un événement, un artiste ou un lieu…": "Search for an event, an artist or a venue…",
  "À la une": "Featured",
  "À venir": "Coming up",
  "Aucun événement trouvé": "No events found",
  "Filtres détaillés": "Advanced filters",
  "Effacer la date": "Clear date",
  "Propriétaire d’un établissement ?": "Own an establishment?",
  "Rejoignez GoSpot et faites découvrir vos événements à des milliers de personnes.": "Join GoSpot and showcase your events to thousands of people.",
  "Publier un événement": "Post an event",
  "Réserver": "Book",

  // Hébergements
  "Hébergements à Québec — GoSpot": "Stays in Quebec City — GoSpot",
  "Hôtels, auberges et hébergements uniques à Québec, avec prix par nuit et carte.": "Hotels, inns and unique stays in Quebec City, with nightly rates and a map.",
  "Rechercher un hôtel, une auberge…": "Search for a hotel, an inn…",
  "Aucun hébergement trouvé": "No stays found",

  // Connexion / compte
  "Bon retour !": "Welcome back!",
  "Crée ton compte": "Create your account",
  "Connecte-toi pour enregistrer tes spots favoris.": "Log in to save your favourite spots.",
  "Rejoins la communauté GoSpot.": "Join the GoSpot community.",
  "Ton nom": "Your name",
  "Courriel": "Email",
  "Mot de passe (6 caractères min.)": "Password (6 characters min.)",
  "Mot de passe oublié ?": "Forgot your password?",
  "Se connecter": "Log in",
  "Créer mon compte": "Create my account",
  "Bon retour sur GoSpot !": "Welcome back to GoSpot!",
  "Bienvenue sur GoSpot !": "Welcome to GoSpot!",
  "Mot de passe oublié — GoSpot": "Forgot your password — GoSpot",
  "Réinitialise ton mot de passe GoSpot.": "Reset your GoSpot password.",
  "Nouveau mot de passe": "New password",
  "Nouveau mot de passe (6 caractères min.)": "New password (6 characters min.)",
  "Choisis ton nouveau mot de passe GoSpot.": "Choose your new GoSpot password.",
  "Confirme le mot de passe": "Confirm password",
  "Confirme le nouveau mot de passe": "Confirm new password",
  "Mot de passe actuel": "Current password",
  "Modifier mon mot de passe": "Change my password",
  "Mot de passe modifié": "Password updated",
  "Mot de passe modifié — connecte-toi !": "Password updated — log in!",
  "Les deux mots de passe ne correspondent pas": "The two passwords don't match",
  "Envoyer le lien": "Send the link",
  "Vérifie ta boîte courriel": "Check your inbox",
  "Si un compte existe avec cette adresse, un courriel avec un lien de réinitialisation vient d'être envoyé. Le lien est valide 30 minutes.": "If an account exists with this address, an email with a reset link has just been sent. The link is valid for 30 minutes.",
  "Entre ton courriel et on t'envoie un lien pour réinitialiser ton mot de passe.": "Enter your email and we'll send you a link to reset your password.",
  "Retour à la connexion": "Back to login",
  "Retour à l'accueil": "Back to home",

  // Profil
  "Mon profil — GoSpot": "My profile — GoSpot",
  "Tes réservations et tes favoris GoSpot.": "Your GoSpot reservations and favourites.",
  "Changer ma photo": "Change my photo",
  "Photo de profil mise à jour !": "Profile photo updated!",
  "Mes réservations": "My reservations",
  "Aucune réservation pour l'instant.": "No reservations yet.",
  "Explorer les événements": "Browse events",
  "Réservation annulée — courriel de confirmation envoyé": "Reservation cancelled — confirmation email sent",
  "Aucun favori pour l'instant. Touche le cœur sur un spot ou un événement pour l'ajouter ici.": "No favourites yet. Tap the heart on a spot or event to add it here.",
  "Aucun favori pour l’instant. Touche le cœur sur un spot ou un événement pour l’ajouter ici.": "No favourites yet. Tap the heart on a spot or event to add it here.",
  "Tous tes coups de cœur, au même endroit.": "All your favourites in one place.",
  "Connecte-toi pour enregistrer tes coups de cœur et les retrouver ici.": "Log in to save your favourites and find them here.",
  "Compte": "Account",

  // Suppression de compte
  "Supprimer mon compte": "Delete my account",
  "Supprimer ton compte ?": "Delete your account?",
  "Action définitive : tes réservations, favoris et données personnelles seront effacés. Tes avis seront anonymisés.": "Permanent action: your reservations, favourites and personal data will be erased. Your reviews will be anonymized.",
  "Cette action est": "This action is",
  "définitive et irréversible": "permanent and irreversible",
  "Voici ce qui va se passer :": "Here's what will happen:",
  "Ton compte et tes informations personnelles seront supprimés": "Your account and personal information will be deleted",
  "Toutes tes réservations et tes favoris seront effacés": "All your reservations and favourites will be erased",
  "Tu seras déconnecté de tous tes appareils (web et mobile)": "You'll be logged out of all your devices (web and mobile)",
  "Tes avis resteront visibles, mais anonymisés (« Utilisateur supprimé »)": "Your reviews will stay visible, but anonymized (“Deleted user”)",
  "Attention — compte Pro": "Warning — Pro account",
  "Ton établissement sera masqué du public et délié de ton compte": "Your establishment will be hidden from the public and unlinked from your account",
  "Tous tes événements seront retirés de la plateforme": "All your events will be removed from the platform",
  "Tout abonnement Pro actif sera annulé": "Any active Pro subscription will be cancelled",
  "Confirme ton identité": "Confirm your identity",
  "Saisis ton mot de passe pour confirmer la suppression définitive de ton compte.": "Enter your password to confirm permanent account deletion.",
  "Ton mot de passe": "Your password",
  "Afficher le mot de passe": "Show password",
  "Masquer le mot de passe": "Hide password",
  "Suppression...": "Deleting...",
  "Supprimer définitivement": "Delete permanently",
  "Ton compte a été supprimé. À bientôt !": "Your account has been deleted. See you soon!",

  // Avis
  "Avis": "Reviews",
  "Connecte-toi pour laisser un avis": "Log in to leave a review",
  "Raconte ton expérience…": "Tell us about your experience…",
  "Publication…": "Posting…",
  "Publier mon avis": "Post my review",
  "Merci pour ton avis !": "Thanks for your review!",
  "Sois le premier à laisser un avis !": "Be the first to leave a review!",
  "Réponse du propriétaire": "Owner's reply",
  "Répondre": "Reply",
  "Modifier la réponse": "Edit reply",
  "Ta réponse": "Your reply",
  "Ta réponse…": "Your reply…",
  "Réponse publiée": "Reply posted",
  "Avis signalé — l'admin va l'examiner": "Review reported — the admin will review it",
  "Signaler cet avis à l'admin GoSpot pour modération ?": "Report this review to the GoSpot admin for moderation?",
  "Supprimer cet avis ?": "Delete this review?",
  "Avis supprimé": "Review deleted",
  "Avis récents": "Recent reviews",
  "Voir tous les avis": "See all reviews",
  "Aucun avis pour le moment.": "No reviews yet.",
  "Aucun avis pour l'instant. Partage ta page pour en recevoir !": "No reviews yet. Share your page to get some!",

  // Fiches détail
  "Établissement introuvable": "Establishment not found",
  "Explorer les spots": "Explore spots",
  "Événement introuvable": "Event not found",
  "Voir les événements": "See events",
  "Partager": "Share",
  "Lien copié !": "Link copied!",
  "À propos": "About",
  "À propos de l’événement": "About this event",
  "Informations": "Information",
  "Horaires": "Hours",
  "Horaires variables": "Hours vary",
  "Emplacement": "Location",
  "C’est ton établissement ?": "Is this your establishment?",
  "Gère ta page, publie tes événements et suis tes statistiques.": "Manage your page, post your events and track your stats.",
  "Accéder à mon espace Pro": "Go to my Pro space",
  "La programmation sera annoncée bientôt.": "The lineup will be announced soon.",
  "Ajoutez à votre calendrier": "Add to your calendar",
  "Événement ajouté à ton calendrier": "Event added to your calendar",
  "Réserver votre place": "Book your spot",
  "Places limitées": "Limited spots",
  "Nombre de personnes": "Number of people",
  "Réservation…": "Booking…",
  "Place réservée ✓": "Spot booked ✓",
  "Réserver maintenant": "Book now",
  "Confirmation instantanée": "Instant confirmation",
  "Ajouter aux favoris": "Add to favourites",
  "Retirer des favoris": "Remove from favourites",
  "Enregistré": "Saved",
  "Photo précédente": "Previous photo",
  "Photo suivante": "Next photo",
  "Photo agrandie": "Enlarged photo",

  // Paiement
  "Paiement — GoSpot": "Payment — GoSpot",
  "Confirmation de ton paiement GoSpot.": "Your GoSpot payment confirmation.",
  "Confirmation du paiement…": "Confirming payment…",
  "Un instant, on vérifie avec Stripe.": "One moment, we're checking with Stripe.",
  "Paiement confirmé !": "Payment confirmed!",
  "Ta place est réservée et ton reçu part par courriel. Retrouve tout dans ton profil.": "Your spot is booked and your receipt is on its way by email. Find everything in your profile.",
  "Voir mes réservations": "See my reservations",
  "Paiement en cours de traitement": "Payment being processed",
  "Session introuvable": "Session not found",
  "Stripe prend un peu plus de temps que prévu. Ta réservation apparaîtra dans ton profil dès confirmation.": "Stripe is taking a bit longer than expected. Your reservation will appear in your profile once confirmed.",
  "Impossible de retrouver cette session de paiement.": "Unable to find this payment session.",
  "Voir mon profil": "See my profile",

  // Publier
  "Publier un événement — GoSpot": "Post an event — GoSpot",
  "Publie ton événement sur GoSpot et fais-le découvrir à des milliers de personnes à Québec.": "Post your event on GoSpot and showcase it to thousands of people in Quebec City.",
  "Modifier l’événement": "Edit event",
  "Ton événement apparaîtra dans la page Événements et dans les suggestions GoSpot.": "Your event will appear on the Events page and in GoSpot suggestions.",
  "Titre de l’événement": "Event title",
  "Titre de l'événement": "Event title",
  "Ex. : Soirée disco au Dagobert": "E.g.: Disco night at Dagobert",
  "Lieu / établissement": "Venue / establishment",
  "Ex. : Le Dagobert": "E.g.: Le Dagobert",
  "Choisir…": "Choose…",
  "Prix par personne ($, 0 = gratuit)": "Price per person ($, 0 = free)",
  "Heure de début": "Start time",
  "Heure de fin": "End time",
  "Description": "Description",
  "Décris l’ambiance, la programmation, ce qui rend ta soirée unique…": "Describe the vibe, the lineup, what makes your night unique…",
  "Décris l'ambiance, la programmation, ce qui rend ton événement unique…": "Describe the vibe, the lineup, what makes your event unique…",
  "Image (URL, optionnel)": "Image (URL, optional)",
  "Enregistrer les modifications": "Save changes",
  "Publier mon événement": "Post my event",
  "Annuler la modification": "Cancel editing",
  "Mes événements publiés": "My posted events",
  "Retirer cet événement de GoSpot ?": "Remove this event from GoSpot?",
  "Événement retiré": "Event removed",
  "Événement mis à jour !": "Event updated!",
  "Événement mis à jour": "Event updated",
  "Événement publié — il est maintenant visible sur GoSpot !": "Event posted — it's now live on GoSpot!",
  "Événement supprimé": "Event deleted",

  // Page mobile
  "Application mobile GoSpot — iOS & Android": "GoSpot mobile app — iOS & Android",
  "Télécharge l'app GoSpot sur ton téléphone : carte plein écran, billets QR, notifications et Espace Pro. Scanne le code pour l'installer avec Expo Go.": "Download the GoSpot app on your phone: full-screen map, QR tickets, notifications and Pro space. Scan the code to install it with Expo Go.",
  "GoSpot dans ta poche": "GoSpot in your pocket",
  "L'application mobile GoSpot : carte plein écran, géolocalisation, billets QR, notifications et ton Espace Pro — synchronisée avec ton compte web.": "The GoSpot mobile app: full-screen map, geolocation, QR tickets, notifications and your Pro space — synced with your web account.",
  "Scanne pour ouvrir l'app": "Scan to open the app",
  "Code QR Expo Go de l'application mobile GoSpot": "Expo Go QR code for the GoSpot mobile app",
  "Via Expo Go — gratuit, rien à créer": "Via Expo Go — free, nothing to set up",
  "Installation en 3 étapes": "Install in 3 steps",
  "Installe Expo Go": "Install Expo Go",
  "Télécharge l'application gratuite Expo Go sur l'App Store (iPhone) ou Google Play (Android).": "Download the free Expo Go app from the App Store (iPhone) or Google Play (Android).",
  "Scanne le code": "Scan the code",
  "Ouvre Expo Go et touche « Scan QR Code » (ou utilise la caméra de ton iPhone, qui détecte Expo Go automatiquement).": "Open Expo Go and tap “Scan QR Code” (or use your iPhone camera, which detects Expo Go automatically).",
  "Profite de GoSpot": "Enjoy GoSpot",
  "L'app se charge avec les vraies données : tes comptes, favoris, réservations et ton Espace Pro.": "The app loads with real data: your accounts, favourites, reservations and your Pro space.",
  "Pensée pour le téléphone": "Designed for your phone",
  "Carte plein écran": "Full-screen map",
  "avec ta position en direct": "with your live location",
  "Photos Pro": "Pro photos",
  "caméra et galerie natives": "native camera and gallery",
  "Scanner de billets": "Ticket scanner",
  "validation QR à l'entrée": "QR check-in at the door",
  "Notifications push": "Push notifications",
  "réponses admin en temps réel": "real-time admin replies",
  "Billets QR": "QR tickets",
  "dans ta poche, hors ligne": "in your pocket, offline",
  "Espace Pro": "Pro space",
  "gestion complète au pouce": "full management at your fingertips",
  "Tu préfères le navigateur ?": "Prefer the browser?",
  "Retour au site GoSpot": "Back to the GoSpot site",

  // Géolocalisation
  "La géolocalisation n'est pas disponible sur cet appareil": "Geolocation is not available on this device",
  "Position détectée — Québec, QC": "Location detected — Quebec City, QC",
  "Impossible de détecter ta position": "Unable to detect your location",
  "Utiliser ma position": "Use my location",

  // Dashboard Pro
  "Mon établissement — GoSpot Pro": "My establishment — GoSpot Pro",
  "Tableau de bord Pro GoSpot pour les établissements.": "GoSpot Pro dashboard for establishments.",
  "Aperçu": "Overview",
  "Vue d'ensemble de ton établissement et de son activité.": "Overview of your establishment and its activity.",
  "Gérez les informations, performances et activités de votre établissement.": "Manage your establishment's information, performance and activity.",
  "Photos": "Photos",
  "Gère la galerie de ta page publique.": "Manage your public page gallery.",
  "Définis tes horaires d'ouverture.": "Set your opening hours.",
  "Créez et gérez les événements de votre établissement.": "Create and manage your establishment's events.",
  "Promotions": "Promotions",
  "Crée des offres visibles sur ta page publique.": "Create offers visible on your public page.",
  "Réservations": "Reservations",
  "Suis toutes les réservations de tes événements.": "Track all reservations for your events.",
  "Lis et réponds aux avis de tes clients.": "Read and reply to your customers' reviews.",
  "Statistiques": "Statistics",
  "Analyse la performance de ton établissement.": "Analyze your establishment's performance.",
  "Contacter l'admin": "Contact admin",
  "Écris à l'équipe GoSpot et suis ses réponses.": "Write to the GoSpot team and track their replies.",
  "Paramètres & forfait": "Settings & plan",
  "Gère ton compte, ta sécurité et tes préférences.": "Manage your account, security and preferences.",
  "Voir ma page publique": "View my public page",
  "Développez votre visibilité et attirez plus de clients.": "Grow your visibility and attract more customers.",
  "Découvrir les avantages": "Discover the benefits",
  "Forfait Pro": "Pro plan",
  "Forfait actuel": "Current plan",
  "Propriétaire": "Owner",
  "Menu du compte": "Account menu",
  "Notifications": "Notifications",
  "3 notifications non lues": "3 unread notifications",
  "Déconnexion réussie": "Logged out successfully",
  "Modifier les infos": "Edit info",
  "Ajouter des photos": "Add photos",
  "Créer un événement": "Create an event",
  "Créer une promotion": "Create a promotion",
  "Informations de l'établissement": "Establishment information",
  "Nom": "Name",
  "Téléphone": "Phone",
  "Site web": "Website",
  "Adresse": "Address",
  "Horaires d'ouverture": "Opening hours",
  "Les horaires peuvent varier lors d'événements spéciaux.": "Hours may vary during special events.",
  "Galerie photos": "Photo gallery",
  "Événements à venir": "Upcoming events",
  "Réservations récentes": "Recent reservations",
  "Actions rapides": "Quick actions",
  "Répondre aux avis": "Reply to reviews",
  "Réponds à tes clients": "Reply to your customers",
  "Mettre à jour les infos": "Update info",
  "Gardez vos infos à jour": "Keep your info up to date",
  "Attirez plus de clients": "Attract more customers",
  "Partager votre page": "Share your page",
  "Augmentez votre visibilité": "Increase your visibility",
  "Conseils de performance": "Performance tips",
  "Publiez un événement": "Post an event",
  "Les établissements qui publient régulièrement des événements attirent 3x plus de vues.": "Establishments that post events regularly get 3x more views.",
  "Modifier les informations": "Edit information",
  "Catégorie (ex. : Bar à cocktails)": "Category (e.g.: Cocktail bar)",
  "Informations mises à jour": "Information updated",
  "Lien de ta page copié !": "Your page link copied!",
  "Vues": "Views",
  "Favoris": "Favourites",
  "Réservation": "Reservation",
  "Inscription": "Signup",
  "Validation": "Validation",
  "Paramètres": "Settings",

  // Vues Pro
  "Formats acceptés : JPG, JPEG, PNG, WebP": "Accepted formats: JPG, JPEG, PNG, WebP",
  "Image trop lourde (max 10 Mo)": "Image too large (max 10 MB)",
  "Taille max. : 10 Mo": "Max size: 10 MB",
  "Affiche de l'événement": "Event poster",
  "Affiche téléversée — recadrage automatique appliqué à l'affichage": "Poster uploaded — automatic cropping applied to the display",
  "Recadrage automatique adapté à l'affichage de la page publique.": "Automatic cropping adapted to the public page display.",
  "Glissez-déposez un fichier": "Drag and drop a file",
  "ou téléversez depuis votre appareil": "or upload from your device",
  "Ajouter une photo / affiche": "Add a photo / poster",
  "Enregistrer le brouillon": "Save draft",
  "Brouillon enregistré": "Draft saved",
  "Statut de publication": "Publication status",
  "Date à définir": "Date to be determined",
  "Type d'événement": "Event type",
  "Choisir une catégorie": "Choose a category",
  "Indique un prix pour un événement payant": "Set a price for a paid event",
  "Nombre de places": "Number of spots",
  "Réservation obligatoire": "Reservation required",
  "Événement récurrent": "Recurring event",
  "Remplis au moins le titre, la catégorie, la date et l'heure de début": "Fill in at least the title, category, date and start time",
  "Aucun événement pour le moment. Crée ton premier événement avec le formulaire ci-contre !": "No events yet. Create your first event with the form next door!",
  "Supprimer cet événement et ses réservations ?": "Delete this event and its reservations?",
  "Gérez vos événements existants. Seuls les événements de votre établissement sont affichés.": "Manage your existing events. Only your establishment's events are shown.",
  "Connecté en tant que propriétaire. Vous gérez uniquement les événements de cet établissement.": "Logged in as owner. You only manage this establishment's events.",
  "Centre-Ville": "Downtown",
  "Définir comme photo principale": "Set as main photo",
  "Retirer cette photo": "Remove this photo",
  "Retirer cette photo de la galerie ?": "Remove this photo from the gallery?",
  "Photo retirée": "Photo removed",
  "Déplacer à gauche": "Move left",
  "Déplacer à droite": "Move right",
  "Ces photos apparaissent sur ta page publique GoSpot. La première photo est ta photo principale (visible dans les listes).": "These photos appear on your GoSpot public page. The first photo is your main photo (shown in listings).",
  "Ajoute d'abord des photos dans la section Photos.": "Add photos in the Photos section first.",
  "Horaires mis à jour — visibles sur ta page publique": "Hours updated — visible on your public page",
  "Définis tes horaires pour chaque jour de la semaine.": "Set your hours for each day of the week.",
  "Ajoute une date et des horaires (ou coche Fermé)": "Add a date and hours (or check Closed)",
  "Exceptions pour une date précise (congé, événement, fermeture exceptionnelle).": "Exceptions for a specific date (holiday, event, exceptional closure).",
  "Aucun horaire spécial. Ajoute une exception ci-dessous.": "No special hours. Add an exception below.",
  "Occasion (ex. : Noël)": "Occasion (e.g.: Christmas)",
  "Ex. : 17h00 – 01h00": "E.g.: 5:00 PM – 1:00 AM",
  "Ex. : 18h00 – 23h00": "E.g.: 6:00 PM – 11:00 PM",
  "Promotion publiée sur ta page": "Promotion posted on your page",
  "Promotion retirée": "Promotion removed",
  "Retirer cette promotion ?": "Remove this promotion?",
  "Aucune promotion active pour le moment.": "No active promotions right now.",
  "Promotions en cours": "Current promotions",
  "Ex. : 2 cocktails pour 15 $ le jeudi": "E.g.: 2 cocktails for $15 on Thursdays",
  "À partir du": "Starting",
  "Jusqu'au": "Until",
  "Visible immédiatement sur ta page publique.": "Immediately visible on your public page.",
  "Les réservations comptent chaque place réservée sur tes événements.": "Reservations count each spot booked on your events.",
  "Les vues comptent chaque visite de ta fiche établissement et de tes événements.": "Views count each visit to your establishment page and events.",
  "7 derniers jours": "Last 7 days",
  "14 derniers jours": "Last 14 days",
  "Activité récente": "Recent activity",
  "Actions suggérées": "Suggested actions",
  "Publier un événement": "Post an event",
  "Créer une promotion": "Create a promotion",
  "Ajouter des photos": "Add photos",
  "Attire 3x plus de vues": "Attracts 3x more views",
  "Booste tes réservations": "Boosts your bookings",
  "Les fiches avec 5+ photos performent mieux": "Listings with 5+ photos perform better",
  "Aucune activité pour l'instant — partage ta page pour attirer des visiteurs !": "No activity yet — share your page to attract visitors!",

  // Claim / établissement
  "Choisis ton établissement": "Choose your establishment",
  "Lie ton établissement à ton compte pour gérer ta page, publier des événements et suivre tes statistiques.": "Link your establishment to your account to manage your page, post events and track your stats.",
  "Établissement existant": "Existing establishment",
  "Nouvel établissement": "New establishment",
  "Lier cet établissement": "Link this establishment",
  "Créer mon établissement": "Create my establishment",
  "Nom de l'établissement": "Establishment name",
  "Ex. : Bar Le Vortex": "E.g.: Bar Le Vortex",
  "Établissement lié à ton compte !": "Establishment linked to your account!",
  "Établissement créé — bienvenue dans GoSpot Pro !": "Establishment created — welcome to GoSpot Pro!",
  "Tous les établissements démo sont déjà liés. Crée le tien dans « Nouvel établissement ».": "All demo establishments are already linked. Create yours under “New establishment”.",
  "Établissement": "Establishment",
  "Devenir Pro": "Become Pro",

  // Messagerie
  "Messagerie": "Messaging",
  "Mes demandes": "My requests",
  "Une question sur ton forfait, ta fiche ou tes événements ? L'admin te répond ici.": "A question about your plan, your listing or your events? The admin replies here.",
  "Sélectionne une demande ou crées-en une nouvelle.": "Select a request or create a new one.",
  "Sujet (ex. : Question sur mon forfait)": "Subject (e.g.: Question about my plan)",
  "Décris ta demande…": "Describe your request…",
  "Écris ta réponse à l'admin…": "Write your reply to the admin…",
  "Ajoute un sujet et un message": "Add a subject and a message",
  "Message envoyé à l'équipe GoSpot": "Message sent to the GoSpot team",
  "Impossible de charger la conversation": "Unable to load the conversation",
  "Joindre un fichier": "Attach a file",
  "Pièce jointe": "Attachment",
  "Pièce jointe prête": "Attachment ready",
  "Retirer la pièce jointe": "Remove attachment",
  "Envoyer à l'admin": "Send to admin",
  "Toi": "You",
  "Besoin d'aide ?": "Need help?",
  "Consulte la messagerie pour répondre aux propriétaires.": "Check messaging to reply to owners.",
  "Aucune demande pour le moment.": "No requests yet.",

  // Paramètres Pro
  "Informations du compte": "Account information",
  "Nom complet": "Full name",
  "Préférences enregistrées": "Preferences saved",
  "Mot de passe": "Password",
  "Nouvelles réservations": "New reservations",
  "Reçois une alerte à chaque réservation sur tes événements.": "Get an alert for each reservation on your events.",
  "Nouveaux avis": "New reviews",
  "Sois notifié quand un client laisse un avis.": "Get notified when a customer leaves a review.",
  "Réponses de l'admin": "Admin replies",
  "Sois notifié quand l'équipe GoSpot répond à tes messages.": "Get notified when the GoSpot team replies to your messages.",
  "Statistiques et support prioritaire": "Statistics and priority support",
  "Événements et promotions illimités": "Unlimited events and promotions",
  "Fiche établissement complète et vérifiée": "Complete verified establishment listing",
  "Gérer mon abonnement avec l'admin": "Manage my subscription with the admin",
  "La gestion de l'abonnement (changement de forfait, facturation) passe par l'équipe GoSpot.": "Subscription management (plan changes, billing) goes through the GoSpot team.",

  // Admin
  "Panneau admin — GoSpot": "Admin panel — GoSpot",
  "Accès réservé": "Restricted access",
  "Ce tableau de bord est réservé aux administrateurs GoSpot.": "This dashboard is reserved for GoSpot administrators.",
  "Tableau de bord": "Dashboard",
  "Établissements": "Establishments",
  "Refuser": "Decline",

  // Footer / divers
  "GoSpot": "GoSpot",
  "Profil": "Profile",
  "Page précédente": "Previous page",
  "Page suivante": "Next page",
  "© 2026 GoSpot — Tous droits réservés.": "© 2026 GoSpot — All rights reserved.",

  // Admin (suite)
  "Utilisateurs": "Users",
  "Revenus": "Revenue",
  "Restaurant": "Restaurant",
  "Hôtel": "Hotel",
  "Auberge": "Inn",
  "Pub irlandais": "Irish pub",
  "Bar à cocktails": "Cocktail bar",
  "vues": "views",
  "spots": "spots",
  "sur": "on",
  "Afficher": "Show",
  "Masquer": "Hide",
  "Exporter le rapport": "Export report",
  "Abonnements": "Subscriptions",
  "Avis à modérer": "Reviews to moderate",
  "Répartition par catégorie": "Breakdown by category",
  "Établissements les plus populaires": "Most popular establishments",
  "Boîte de réception": "Inbox",
  "Total des comptes actifs": "Total active accounts",
  "Aucune activité récente.": "No recent activity.",
  "Aucune vue enregistrée pour le moment.": "No views recorded yet.",
  "Aucun message pour le moment": "No messages yet",
  "Aucune demande en attente. Les revendications et créations d'établissements Pro apparaîtront ici.": "No pending requests. Pro establishment claims and creations will appear here.",
  "Les demandes de support des propriétaires Pro apparaîtront ici.": "Support requests from Pro owners will appear here.",
  "Sélectionne une conversation pour lire les messages.": "Select a conversation to read the messages.",
  "Écris ta réponse au propriétaire…": "Write your reply to the owner…",
  "Vue d'ensemble de la plateforme GoSpot.": "Overview of the GoSpot platform.",
  "Approuve ou refuse les demandes des propriétaires Pro.": "Approve or decline Pro owner requests.",
  "Gère la visibilité des spots sur la plateforme.": "Manage spot visibility on the platform.",
  "Réponds aux demandes de support des propriétaires Pro.": "Reply to support requests from Pro owners.",
  "Pro": "Pro",

  // Publicités
  "Publicité": "Advertisement",
  "Publicités": "Ads",
  "Découvrir": "Discover",
  "Gérez vos affiches publicitaires sur GoSpot.": "Manage your ad banners on GoSpot.",
  "Ajouter une publicité": "Add an ad",
  "Modifier la publicité": "Edit ad",
  "Titre de la publicité": "Ad title",
  "Accroche (ex. : BAR • SPECTACLES • BONNE AMBIANCE)": "Tagline (e.g.: BAR • SHOWS • GREAT VIBES)",
  "Slogan (ex. : Vos soirées prennent vie ici !)": "Slogan (e.g.: Your nights come alive here!)",
  "Lien de destination (https://…)": "Destination link (https://…)",
  "Affiche (1200 × 400 px, ratio 3:1)": "Poster (1200 × 400 px, 3:1 ratio)",
  "Téléverser": "Upload",
  "Caractéristiques (3 max, séparées par des virgules)": "Features (max 3, comma separated)",
  "Date de début": "Start date",
  "Date de fin": "End date",
  "Publicité active (visible sur l'accueil pendant la période)": "Active ad (visible on the homepage during the period)",
  "Ajouter la publicité": "Add ad",
  "Publicité créée": "Ad created",
  "Publicité mise à jour": "Ad updated",
  "Publicité supprimée": "Ad deleted",
  "Supprimer cette publicité ?": "Delete this ad?",
  "Aucune publicité pour le moment.": "No ads yet.",
  "Formats recommandés pour le poster": "Recommended poster formats",
  "Format desktop (accueil)": "Desktop format (homepage)",
  "Taille recommandée : 1200 × 400 px (ratio 3:1)": "Recommended size: 1200 × 400 px (3:1 ratio)",
  "Types : JPG, PNG": "Types: JPG, PNG",
  "Poids max : 2 Mo": "Max weight: 2 MB",
  "Image": "Image",
  "Titre": "Title",
  "Lien": "Link",
  "Période": "Period",
  "Active": "Active",
  "Désactivée": "Disabled",
  "En continu": "Ongoing",
  "Aperçu": "Preview",
  "Image trop lourde (max 2 Mo)": "Image too large (max 2 MB)",

  // Bannière d'accueil (admin)
  "Bannière d'accueil": "Homepage banner",
  "Changez l'image principale du hero de la page d'accueil.": "Change the homepage hero image.",
  "Image actuelle": "Current image",
  "Image par défaut": "Default image",
  "Nouvelle image (prévisualisation)": "New image (preview)",
  "Changer l'image": "Change image",
  "Prévisualisation — non enregistrée": "Preview — not saved",
  "Poids max : 5 Mo": "Max weight: 5 MB",
  "Image trop lourde (max 5 Mo)": "Image too large (max 5 MB)",
  "Bannière mise à jour — visible sur l'accueil": "Banner updated — live on the homepage",
  "L'image s'adapte automatiquement au format desktop et mobile de la page d'accueil. Sans image personnalisée, la bannière par défaut de GoSpot est utilisée.": "The image automatically adapts to the homepage's desktop and mobile formats. Without a custom image, GoSpot's default banner is used.",

  "Inactive": "Inactive",
  "Activer la publicité": "Enable ad",
  "Désactiver la publicité": "Disable ad",
  "Publicité activée — visible publiquement": "Ad enabled — publicly visible",
  "Publicité désactivée — masquée du public": "Ad disabled — hidden from the public",

  // Publication d'événements par les membres + modération admin
  "Modifier l'événement": "Edit event",
  "Partage ton événement avec la communauté GoSpot — aucun établissement requis.": "Share your event with the GoSpot community — no establishment required.",
  "Ton événement sera vérifié par l'équipe GoSpot avant sa publication.": "Your event will be reviewed by the GoSpot team before it goes live.",
  "Ex. : Soirée jeux de société entre amis": "E.g.: Board game night with friends",
  "Décris l'ambiance, le programme, ce qui rend ton événement unique…": "Describe the vibe, the lineup, what makes your event unique…",
  "Retirer l'image": "Remove image",
  "Téléversement…": "Uploading…",
  "Choisir une image": "Choose an image",
  "Format paysage recommandé (JPG ou PNG, max 10 Mo).": "Landscape format recommended (JPG or PNG, max 10 MB).",
  "Ajoute une image pour illustrer ta fiche événement.": "Add an image to illustrate your event page.",
  "Une image est requise pour publier l'événement": "An image is required to publish the event",
  "Nom du lieu": "Venue name",
  "Adresse": "Address",
  "Ex. : Café Néron": "E.g.: Café Néron",
  "Ex. : 123 rue Saint-Jean": "E.g.: 123 Saint-Jean Street",
  "Ville": "City",
  "Prix par personne ($)": "Price per person ($)",
  "Indique le prix par personne ou coche Gratuit.": "Enter the price per person or check Free.",
  "Lien de réservation (optionnel)": "Booking link (optional)",
  "Téléphone (optionnel)": "Phone (optional)",
  "Publier l'événement": "Publish event",
  "Événement soumis ! Il sera publié après validation par l'équipe GoSpot.": "Event submitted! It will be published once reviewed by the GoSpot team.",
  "Modifications enregistrées — ton événement repasse en validation.": "Changes saved — your event goes back to review.",
  "Mes événements": "My events",
  "Aucun événement soumis pour l'instant.": "No events submitted yet.",
  "Supprimer cet événement ?": "Delete this event?",
  "Refusé": "Rejected",
  "Raison du refus": "Reason for rejection",
  "Valide et modère les événements soumis sur GoSpot.": "Review and moderate events submitted on GoSpot.",
  "Publiés": "Published",
  "Refusés": "Rejected",
  "Source": "Source",
  "Utilisateur": "User",
  "Établissement Pro": "Pro establishment",
  "Équipe GoSpot": "GoSpot team",
  "Voir": "View",
  "Approuver": "Approve",
  "Événement approuvé — il est maintenant visible publiquement.": "Event approved — it is now publicly visible.",
  "Événement refusé — visible uniquement par son auteur.": "Event rejected — only visible to its author.",
  "Événement repassé en attente.": "Event moved back to pending.",
  "Refuser l'événement": "Reject event",
  "Raison du refus (optionnelle)": "Reason for rejection (optional)",
  "Ex. : informations insuffisantes, contenu inapproprié…": "E.g.: insufficient information, inappropriate content…",
  "L'événement refusé restera visible uniquement dans « Mes événements » de son auteur.": "A rejected event remains visible only in its author's “My events” section.",
  "Confirmer le refus": "Confirm rejection",
  "Aucun événement ne correspond à ces filtres.": "No events match these filters.",
  "Organisateur": "Organizer",
  "Soumis le": "Submitted on",
  "Détails de l'événement": "Event details",
  "Lien de réservation": "Booking link",
  "Téléphone": "Phone",

  // Statut « Établissement de démonstration »
  "Démo": "Demo",
  "Établissement de démonstration": "Demo establishment",
  "Oui": "Yes",
  "Non": "No",
  "Basculer le statut Démo": "Toggle Demo status",
  "Statut Démo activé": "Demo status enabled",
  "Statut Démo désactivé": "Demo status disabled",

  // Menu profil + paramètres du panneau admin
  "Nom mis à jour": "Name updated",
  "Modifier le mot de passe": "Change password",
  "Membre depuis": "Member since",
  "Modification…": "Updating…",

  // Statistiques de visites (tableau de bord admin)
  "Visiteurs aujourd'hui": "Visitors today",
  "Visiteurs uniques (7 jours)": "Unique visitors (7 days)",
  "Visiteurs uniques (30 jours)": "Unique visitors (30 days)",
  "Pages vues (total)": "Total page views",
  "Visites du site": "Site visits",
  "Aujourd'hui": "Today",
  "7 jours": "7 days",
  "30 jours": "30 days",
  "Pages vues": "Page views",
  "Visiteurs uniques": "Unique visitors",

  // Œil d'affichage du mot de passe (connexion / inscription)
  "Confirme ton mot de passe": "Confirm your password",
  "Afficher le mot de passe": "Show password",
  "Masquer le mot de passe": "Hide password",

  // Bannière d'accueil — limite 15 Mo
  "Image trop lourde (max 15 Mo)": "Image too large (max 15 MB)",
  "Poids max : 15 Mo": "Max size: 15 MB",
  "Fichier trop lourd (max 15 Mo)": "File too large (max 15 MB)",

  // Bannière d'accueil — compression automatique + recadrage
  "Recadrer l'image": "Crop image",
  "Recadrage de la bannière": "Banner cropping",
  "Ajuste le cadrage pour le desktop et le mobile, puis applique.": "Adjust the framing for desktop and mobile, then apply.",
  "Zoom": "Zoom",
  "Appliquer le recadrage": "Apply crop",
  "Recadrage appliqué — pense à enregistrer.": "Crop applied — remember to save.",
  "Aperçu mobile": "Mobile preview",
  "Image illisible — essaie un autre fichier": "Unreadable image — try another file",
  "Optimisée automatiquement en WebP à l'enregistrement": "Automatically optimized to WebP on save",

  // Mode maintenance
  "Mode maintenance": "Maintenance mode",
  "Inactif": "Inactive",
  "Quand il est actif, le site public affiche une page de maintenance. L'espace admin reste accessible.": "When active, the public site shows a maintenance page. The admin area stays accessible.",
  "GoSpot est temporairement en maintenance": "GoSpot is temporarily down for maintenance",
  "Nous améliorons la plateforme. Revenez bientôt.": "We're improving the platform. Come back soon.",
  "Mode maintenance activé — le site public est masqué.": "Maintenance mode on — the public site is now hidden.",
  "Mode maintenance désactivé — le site est de nouveau accessible.": "Maintenance mode off — the site is back online.",
  "Basculer le mode maintenance": "Toggle maintenance mode",
  "Mode maintenance actif — le site public est masqué aux visiteurs.": "Maintenance mode is on — the public site is hidden from visitors.",
  "Désactiver": "Disable",

  // Espace admin séparé (admin.gospot.ca)
  "Espace administrateur": "Admin area",
  "Connexion à l'administration": "Administration sign-in",
  "Réservé à l'équipe GoSpot.": "Reserved for the GoSpot team.",
  "Accès réservé aux administrateurs.": "Access restricted to administrators.",
  "Retour au site public": "Back to the public site",
  "Connexion…": "Signing in…",
};
